import { useState } from 'react';

export default function Portfolio() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const portfolioItems = [
    {
      title: 'Özel Hastane Temizliği',
      category: 'Sağlık Tesisi',
      image: 'https://public.readdy.ai/ai/img_res/249459ad38dc047afcd3627fcf5ca611.jpg',
      description: 'Ameliyathane ve hasta odalarının steril temizliği'
    },
    {
      title: 'Alışveriş Merkezi Bakımı',
      category: 'Perakende',
      image: 'https://readdy.ai/api/search-image?query=Commercial%20cleaning%20crew%20in%20Roba%20Temizlik%20branded%20uniforms%20polishing%20large%20shopping%20mall%20floors%2C%20professional%20team%20with%20cleaning%20equipment%20in%20modern%20retail%20center%2C%20uniform%20text%20Roba%20Temizlik%20clearly%20visible%2C%20sparkling%20clean%20marble%20floors%2C%20contemporary%20shopping%20center%20maintenance&width=800&height=600&seq=portfolio-002&orientation=landscape',
      description: 'Geniş alanlarda zemin cilalama ve bakım'
    },
    {
      title: 'Kurumsal Ofis Temizliği',
      category: 'Ofis',
      image: 'https://readdy.ai/api/search-image?query=Office%20cleaning%20professionals%20wearing%20Roba%20Temizlik%20logo%20uniforms%20cleaning%20modern%20corporate%20office%2C%20team%20members%20in%20branded%20workwear%20with%20Daha%20Temiz%20Bir%20D%C3%BCnya%20%C4%B0%C3%A7in%20slogan%2C%20contemporary%20business%20environment%2C%20professional%20commercial%20cleaning%20service%2C%20sleek%20office%20interior&width=800&height=600&seq=portfolio-003&orientation=landscape',
      description: 'Günlük ofis temizlik ve bakım hizmetleri'
    },
    {
      title: 'Otel Oda Temizliği',
      category: 'Konaklama',
      image: 'https://readdy.ai/api/search-image?query=Hotel%20housekeeping%20staff%20in%20Roba%20Temizlik%20branded%20uniforms%20preparing%20luxury%20hotel%20room%2C%20professional%20cleaners%20wearing%20company%20logo%20workwear%2C%20pristine%20white%20linens%2C%20elegant%20hospitality%20service%2C%20five%20star%20hotel%20room%20maintenance%2C%20immaculate%20guest%20room&width=800&height=600&seq=portfolio-004&orientation=landscape',
      description: 'Lüks otel odalarında premium temizlik'
    },
    {
      title: 'Okul Temizliği',
      category: 'Eğitim',
      image: 'https://readdy.ai/api/search-image?query=School%20cleaning%20team%20wearing%20Roba%20Temizlik%20logo%20uniforms%20sanitizing%20bright%20modern%20classroom%2C%20workers%20in%20branded%20cleaning%20uniforms%20with%20Daha%20Temiz%20Bir%20D%C3%BCnya%20%C4%B0%C3%A7in%20slogan%2C%20child-friendly%20cleaning%20service%2C%20educational%20facility%20maintenance%2C%20pristine%20school%20environment&width=800&height=600&seq=portfolio-005&orientation=landscape',
      description: 'Güvenli ve hijyenik eğitim ortamları'
    },
    {
      title: 'Spor Salonu Hijyeni',
      category: 'Spor Tesisi',
      image: 'https://readdy.ai/api/search-image?query=Fitness%20center%20cleaning%20professionals%20in%20Roba%20Temizlik%20branded%20uniforms%20disinfecting%20gym%20equipment%2C%20cleaning%20team%20wearing%20company%20logo%20workwear%2C%20modern%20fitness%20facility%20maintenance%2C%20professional%20sports%20facility%20cleaning%2C%20pristine%20workout%20environment&width=800&height=600&seq=portfolio-006&orientation=landscape',
      description: 'Ekipman dezenfeksiyonu ve alan bakımı'
    },
    {
      title: 'Banka Şubesi Temizliği',
      category: 'Finans',
      image: 'https://readdy.ai/api/search-image?query=Bank%20cleaning%20crew%20wearing%20Roba%20Temizlik%20logo%20uniforms%20maintaining%20modern%20financial%20institution%2C%20professional%20cleaners%20in%20branded%20workwear%20with%20Daha%20Temiz%20Bir%20D%C3%BCnya%20%C4%B0%C3%A7in%20slogan%2C%20pristine%20banking%20hall%20with%20marble%20floors%2C%20contemporary%20bank%20interior%20cleaning&width=800&height=600&seq=portfolio-007&orientation=landscape',
      description: 'Müşteri alanları ve ofislerin bakımı'
    },
    {
      title: 'Restoran Mutfak Temizliği',
      category: 'Yemek Servisi',
      image: 'https://readdy.ai/api/search-image?query=Commercial%20kitchen%20cleaning%20team%20in%20Roba%20Temizlik%20branded%20uniforms%20deep%20cleaning%20restaurant%20kitchen%2C%20workers%20wearing%20company%20logo%20workwear%2C%20stainless%20steel%20surfaces%20sparkling%20clean%2C%20professional%20food%20service%20cleaning%2C%20industrial%20kitchen%20maintenance&width=800&height=600&seq=portfolio-008&orientation=landscape',
      description: 'Sağlık kodlarına uygun mutfak temizliği'
    },
    {
      title: 'İnşaat Sonrası Temizlik',
      category: 'İnşaat',
      image: 'https://readdy.ai/api/search-image?query=Construction%20cleaning%20team%20wearing%20Roba%20Temizlik%20logo%20uniforms%20removing%20debris%20from%20newly%20built%20office%2C%20professional%20cleaners%20in%20branded%20workwear%20with%20Daha%20Temiz%20Bir%20D%C3%BCnya%20%C4%B0%C3%A7in%20slogan%2C%20post%20construction%20cleanup%20service%2C%20modern%20building%20interior%2C%20pristine%20new%20construction&width=800&height=600&seq=portfolio-009&orientation=landscape',
      description: 'Yeni binaların teslim öncesi temizliği'
    }
  ];

  const categories = ['Tümü', ...Array.from(new Set(portfolioItems.map(item => item.category)))];
  const [activeCategory, setActiveCategory] = useState('Tümü');

  const filteredItems = activeCategory === 'Tümü' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeCategory);

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Yapılan İşler
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Farklı sektörlerde gerçekleştirdiğimiz profesyonel temizlik projelerinden örnekler. Her projede aynı kalite ve özveriyle çalışıyoruz.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === category
                  ? 'bg-teal-600 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredItems.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl shadow-lg cursor-pointer hover:shadow-2xl transition-all duration-300"
              onClick={() => setSelectedImage(index)}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <div className="inline-block bg-teal-600 text-white text-sm px-3 py-1 rounded-full mb-3">
                    {item.category}
                  </div>
                  <h3 className="text-2xl font-bold mb-2">{item.title}</h3>
                  <p className="text-gray-200">{item.description}</p>
                  <div className="mt-4 flex items-center gap-2">
                    <i className="ri-zoom-in-line text-xl"></i>
                    <span className="text-sm">Detayları Görüntüle</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedImage !== null && (
          <div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute top-6 right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors cursor-pointer"
              onClick={() => setSelectedImage(null)}
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            <div className="max-w-6xl w-full">
              <img
                src={filteredItems[selectedImage].image}
                alt={filteredItems[selectedImage].title}
                className="w-full h-auto rounded-lg"
                onClick={(e) => e.stopPropagation()}
              />
              <div className="mt-6 text-center text-white">
                <div className="inline-block bg-teal-600 text-white text-sm px-4 py-2 rounded-full mb-3">
                  {filteredItems[selectedImage].category}
                </div>
                <h3 className="text-3xl font-bold mb-2">{filteredItems[selectedImage].title}</h3>
                <p className="text-xl text-gray-300">{filteredItems[selectedImage].description}</p>
              </div>
            </div>
            <button
              className="absolute left-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage > 0 ? selectedImage - 1 : filteredItems.length - 1);
              }}
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>
            <button
              className="absolute right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage < filteredItems.length - 1 ? selectedImage + 1 : 0);
              }}
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
          </div>
        )}

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-teal-50 px-8 py-4 rounded-full">
            <i className="ri-heart-line text-2xl text-teal-600"></i>
            <span className="text-lg font-semibold text-gray-900">Daha Temiz Bir Dünya İçin</span>
          </div>
        </div>
      </div>
    </section>
  );
}
